// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.
//

// Import CSS
//  removed to get Tailwind working. /bw
// import "../css/index.css";

// Import JS
// import menuOpen from "./menuOpen";
import Glide from "@glidejs/glide";

// Call the menu and infinite scroll functions
// menuOpen();
// infiniteScroll();
//
let serviceCardsGlide;

function initGlide() {
  const glideFeaturedElement = document.querySelector(".glide-featured-home");
  if (glideFeaturedElement) {
    const perView = parseInt(glideFeaturedElement.dataset.perView, 10) || 4;
    const actualPerView = Math.min(perView, 4);

    new Glide(".glide-featured-home", {
      type: "carousel",
      startAt: 0,
      perView: actualPerView,
      gap: 30,
      autoplay: false,
      hoverpause: true,
      breakpoints: {
        992: {
          perView: Math.min(actualPerView, 3),
        },
        768: {
          perView: Math.min(actualPerView, 2),
        },
        576: {
          perView: 1,
        },
      },
    }).mount();
  }

  const glideTestimonialsElement = document.querySelector(
    ".glide-testimonials-home",
  );
  if (glideTestimonialsElement) {
    new Glide(".glide-testimonials-home", {
      type: "carousel",
      startAt: 0,
      perView: 3,
      gap: 60,
      autoplay: false,
      breakpoints: {
        1220: {
          perView: 2,
          gap: 50,
        },
        1023: {
          perView: 1,
          gap: 40,
        },
        900: {
          perView: 1,
          gap: 0,
        },
      },
    }).mount();
  }

  const serviceCardsContainer = document.querySelector(
    ".service-card-container",
  );

  if (serviceCardsContainer) {
    if (serviceCardsContainer.dataset.useGlide === "true") {
      // Add the 'glide' class to the container
      serviceCardsContainer.classList.add("glide-service-cards");

      // Safely add class to page-services if it exists
      document.querySelector(".page-services")?.classList.add("glide-is-on");

      // Safely add class to home-services if it exists
      document.querySelector(".home-services")?.classList.add("glide-is-on");

      // Initialize Glide
      serviceCardsGlide = new Glide(".service-card-container", {
        type: "slider",
        startAt: 1,
        perView: 3,
        focusAt: "left",
        gap: 20,
        autoplay: false,
        breakpoints: {
          956: {
            perView: 1.5,
            focusAt: "center",
            gap: 0,
            peek: {
              before: 100,
              after: 100,
            },
          },
          640: {
            perView: 1.8,
            focusAt: "center",
            gap: 0,
            peek: {
              before: 50,
              after: 50,
            },
          },
          520: {
            perView: 1.5,
            focusAt: "center",
            gap: 0,
            peek: {
              before: 50,
              after: 50,
            },
          },
          450: {
            perView: 1.4,
            focusAt: "center",
            gap: 0,
            peek: {
              before: 50,
              after: 50,
            },
          },
          400: {
            perView: 1.2,
            focusAt: "center",
            gap: 0,
            peek: {
              before: 50,
              after: 50,
            },
          },
        },
      });
      serviceCardsGlide.mount();
    }
  }
}

// function handleSlideClick(event, glide) {
//   console.log("Slide clicked", event);
//   event.preventDefault(); // Prevent default for all slides

//   const clickedSlide = event.target.closest(".glide__slide");
//   if (!clickedSlide) return;

//   if (clickedSlide.classList.contains("glide__slide--active")) {
//     console.log("Active slide clicked");
//     // For now, we're just logging this. We'll enable the link later.
//   } else {
//     console.log("Non-active slide clicked");
//     const slides = Array.from(glide.selector.querySelectorAll(".glide__slide"));
//     const clickedIndex = slides.indexOf(clickedSlide);
//     console.log("Moving to index", clickedIndex);
//     glide.go(`=${clickedIndex}`);
//   }
// }

function initStickyHeader() {
  const header = document.querySelector(".sticky-header");
  let isScrolled = false;
  let lastScrollTop = 0;
  let ticking = false;

  function handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (!ticking) {
      window.requestAnimationFrame(() => {
        if (scrollTop > 0) {
          if (!isScrolled) {
            header.classList.add("scrolled");
            isScrolled = true;
          }
        } else {
          if (isScrolled) {
            header.classList.remove("scrolled");
            isScrolled = false;
          }
        }
        lastScrollTop = scrollTop;
        ticking = false;
      });

      ticking = true;
    }
  }

  // Handle both scroll and touch events
  ["scroll", "touchmove", "touchend"].forEach((eventName) => {
    window.addEventListener(eventName, handleScroll, { passive: true });
  });

  // Initial check in case the page is loaded scrolled
  handleScroll();
}

function checkBreakpoint() {
  const breakpoint = 956;
  let isAboveBreakpoint = window.innerWidth > breakpoint;

  function handleResize() {
    if (window.innerWidth > breakpoint !== isAboveBreakpoint) {
      isAboveBreakpoint = !isAboveBreakpoint;
      console.log(
        `Crossed ${isAboveBreakpoint ? "above" : "below"} 956px breakpoint`,
      );

      if (serviceCardsGlide) {
        serviceCardsGlide.destroy();
        serviceCardsGlide = null; // Clear the reference
      }
      initGlide(); // This will reinitialize serviceCardsGlide if needed
      console.log("Service Cards Glide instance reinitialized");
    }
  }

  window.addEventListener("resize", handleResize);
  // Call once to set initial state
  handleResize();
}

document.addEventListener("DOMContentLoaded", () => {
  initGlide();
  initStickyHeader();
  checkBreakpoint();
});
